import PropTypes from 'prop-types';
import React from 'react'
import { Link } from 'react-router-dom'
import { findWhere } from 'underscore'

import { toggleArticleBookmark } from '~/actions/article'

import { Icon } from '~/components'
import timestamps from '~/services/timestamps'
import TextEdit from '~/services/textedit'


export default class extends React.Component {
    static propTypes = {
		user: PropTypes.object.isRequired,
		bookmarks: PropTypes.array.isRequired,
		comment_count: PropTypes.number.isRequired,
		date: PropTypes.string.isRequired,
		excerpt: PropTypes.string,
		flares: PropTypes.array.isRequired,
		images: PropTypes.object.isRequired,
		ID: PropTypes.number,
		interests: PropTypes.array,
		read_time: PropTypes.number.isRequired,
		slug: PropTypes.string.isRequired,
		title: PropTypes.string.isRequired,
	};

    state = {
        bookmarked: !!findWhere(this.props.bookmarks, function(b) { return b.ID === this.props.session.user.ID })
    };

    bookmark = () => {
		this.props.dispatch( toggleArticleBookmark(this.props.ID) )
	};

    render() {

		var article = this.props,
			bookmarked = this.state.bookmarked;

		return (
			<div className="col-sm-12 panel ptop15 mbot0">
				<div className="horizontal-article-holder">
					<div className="row">
						<div className="col-xs-12">
							<div className="profile-image-wrapper mright10">
								<Link to={article.user.link}>
									<div className="profile-image" style={{backgroundImage: 'url(' + article.user.profile_picture + ')'}}></div>
								</Link>
							</div>
							<div className="pull-left">
								<h5 className="mtop0 mbot5">
									<strong>
										<Link to={article.user.link} className="no-style">
											{article.user.first + ' ' + article.user.last}
										</Link>
									</strong> posted an article
								</h5>
								<p className="text-pale-main">{'Posted ' + timestamps.timeSince(article.date, true)}</p>
							</div>
						</div>
						<div className="clearfix"></div>
						<hr className="mbot15 mtop15" />
					</div>
					<div className="narrow-gutter pbot15">
						<div className="row full-height">
		            		<div className="col-sm-6 match-height">
		            			<Link to={article.link}>
		            				<div className="fill-image">
										<div className="background-fill clickable" style={{backgroundImage: 'url(' + article.images.banner + ')'}} />
									</div>
	            				</Link>
		            		</div>
		            		<div className="col-sm-6 ptop10 pbot15 match-height">

			            		<div className="content">

			            			<Link to={article.link}>
										<h3 className="mtop0 mbot15">{article.title}</h3>
				        			</Link>

									<p className="">{ TextEdit.cutText(article.excerpt, 120) }</p>

									<p className="details text-dark-gray">
										{ article.interests.length > 0 &&
											<span>
												<span className=""><Icon icon={'interests'} className={'text-dark-gray'} /> </span>
												{ article.interests.slice(0,3).map(interest => {
													return <span className="mright10" key={article.ID+'-tags-'+interest.ID}>{interest.tag}</span>
												}) }
												<br />
											</span>
										}
										<span className="mright20"><Icon icon={'comments'} className={'text-dark-gray'} /> {article.comment_count} comments</span>
										<span className="mright20"><Icon icon={'bookmarks'} className={'text-dark-gray'} /> {article.bookmarks.length}</span>
										<span className="mright20"><Icon icon={'flares'} className={'text-dark-gray'} /> {article.flares.length}</span>
										<span className="mright20">{article.read_time + ' min read'}</span>
									</p>

								</div>

								<div className="clearfix"></div>

		            		</div>
		        		</div>
		    		</div>
				</div>
			</div>
		)

	}
}



// WEBPACK FOOTER //
// ./src/js/views/Community/MainFeeds/ContentParts/ContentPart-Article.jsx